export default __webpack_public_path__ + "static/media/Accordion-close.9c246915.svg";